exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.checkbox[data-v-007693ee] {\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n.checkbox p[data-v-007693ee],\n.checkbox input[data-v-007693ee]\n{\n    vertical-align: middle;\n}\ninput[type=\"checkbox\"][data-v-007693ee]{\n    width: 25px;\n    height: 25px;\n}\n", ""]);

// exports
